<template>
  <v-card outlined>
    <v-container>
      <v-toolbar flat dense>
        <div>{{$t("deliveryMethod.deliveryTypes")}}</div>
      </v-toolbar>
      <v-autocomplete
        v-model="eligibilityConditions.delivery_types"
        :items="deliveryTypes"
        :disabled="loading"
        :label="$t('deliveryMethod.deliveryTypes')"
        class="d-flex justify-center align-center py-2"
        dense
        multiple
        hide-details="auto"
        outlined
        small-chips
        clearable
      ></v-autocomplete>
    </v-container>
  </v-card>
</template>

<script>

  export default {
    name: "deliveryTypesEligibility",
    props: {
      eligibilityConditions: {
        type: Object,
        default: null,
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        deliveryTypes: [
          { text: this.$t('order.homeDelivery'), value: 'home_delivery' },
          { text: this.$t('order.storeDelivery'), value: 'store_delivery' },
          { text: this.$t('order.relayPointDelivery'), value: 'relay_point_delivery' }
        ]
      }
    },
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.width <= 600
      },
    }
  }
</script>

